const actionScope = '[Email Confirmation]';

export class ConfirmEmail {
  static readonly type = `${actionScope} Confirm Email`;

  constructor(public token: string) {}
}

export class ConfirmEmailSuccess {
  static readonly type = `${actionScope} Confirm Email Success`;
}
